export default "__VITE_ASSET__D$ub7_Ky__"